module.exports = __webpack_public_path__ + "static/media/bring-forward.ba34dc75.svg";